import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import noop from 'lodash-es/noop';
import styled from 'styled-components';
import styles from '../styles';
import SlideThumb from './SlideThumb';
import Color from 'color';

const SlideHint = styled.div`
  position: fixed;
  left: 7px;
  bottom: 9px;
  z-index: 11;
  width: 111px;
  margin-left: 0px;
  top: calc(50% - 20px);
  background: #000000ad;
  height: 40px;
  width: 20px;
  display: grid;
  opacity: ${props => (props.hide ? 0 : 1)};
  transform: ${props => (props.hide ? 'translateX(-20px)' : 'translateX(0px)')};
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  transition: all 0.25s ease-in-out;
`;

const SlidesList = props => {
  const [slides, setSlides] = React.useState(props.slides);
  const onMouseEnter = () => {
    props.onMouseEnter();
  };

  const onMouseLeave = () => {
    props.onMouseLeave();
  };

  React.useEffect(() => {
    setSlides(props.slides);
  }, [props.slides]);

  const slidesContainerStyles = {
    ...styles.slidesContainer,
    top: props.topOffset,
    transform: `translateZ(0px) translateX(${
      props.slidesShowed ? 0 : '-145px'
    })`,
  };

  const slidesListStyles = {
    ...styles.slidesList,
  };

  const backgroundColor = props.slides[props.currentSlide].content.background;

  return (
    <div
      style={{
        display: props.visible ? 'block' : 'none',
      }}
    >
      <div
        style={slidesContainerStyles}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <div
          style={slidesListStyles}
          className={
            Color(backgroundColor).isDark()
              ? 'slides-list-dark'
              : 'slides-list-light'
          }
        >
          <div>
            {slides.map((slide, i) => (
              <SlideThumb
                json={slide.content}
                key={`slide-thumbnails-${i}`}
                index={i}
              />
            ))}
          </div>
        </div>
      </div>
      <SlideHint hide={props.slidesShowed || !props.controlsVisible}>
        <svg
          width="6"
          height="19"
          viewBox="0 0 6 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.5"
            y="0.5"
            width="5"
            height="4"
            rx="0.5"
            stroke="white"
            strokeOpacity="0.7"
          />
          <rect
            x="0.5"
            y="7.5"
            width="5"
            height="4"
            rx="0.5"
            stroke="white"
            strokeOpacity="0.7"
          />
          <rect
            x="0.5"
            y="14.5"
            width="5"
            height="4"
            rx="0.5"
            stroke="white"
            strokeOpacity="0.7"
          />
        </svg>
      </SlideHint>
    </div>
  );
};

SlidesList.propTypes = {
  slides: PropTypes.arrayOf(PropTypes.object).isRequired,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  slidesShowed: PropTypes.bool.isRequired,
  currentSlide: PropTypes.number,
  controlsVisible: PropTypes.bool,
  topOffset: PropTypes.string,
  visible: PropTypes.bool.isRequired,
};

SlidesList.defaultProps = {
  onMouseEnter: noop,
  onMouseLeave: noop,
  topOffset: '0px',
};

const mapStateToProps = state => ({
  currentSlide: state.slideReducer.index,
  totalSlides: state.slideReducer.slides.length,
  slides: state.slideReducer.slides,
});

export default connect(mapStateToProps)(SlidesList);
